declare global {
  interface Window {
    REACT_APP_IMAGE_SERVER_URL?: string;
    REACT_APP_FE_URL?: string;
    REACT_APP_DEPLOYMENT?: string;
  }
}

// The Go server hosts the SPA and the API on the same origin, so relative
// URLs work in every deployment; REACT_APP_API_URL is only a dev override.
const apiBaseUrl = process.env.REACT_APP_API_URL || "";

const imageServerUrl =
  window.REACT_APP_IMAGE_SERVER_URL || "https://beta.tiedot.info";

export { apiBaseUrl, imageServerUrl };

export const imageSizes = {
  thumbnail: "width=210,height=140,fit=cover,quality=100",
  medium: "width=600,height=400,fit=cover,quality=100",
  large: "width=1920,height=1280,fit=cover,quality=100",
  // Favicons render into a square tab slot, so the logo must be square and
  // uncropped — `fit=contain` fits the whole mark inside the square instead of
  // cover-cropping it (the 3:2 `thumbnail` distorted it). Keep this string in
  // sync with faviconTransform in custom-website-be/main.go.
  favicon: "width=256,height=256,fit=contain,quality=100",
};
